<template>
  <!-- 发货详情-->
  <div class="logistics-detail">
    <detailEdit 
      v-if="[undefined, 'add', 'edit'].includes(routeQuery.action)"
      :options="options"
      :dataForm="dataForm"
      @deleteEntry="(row) => deleteEntry.push(row)"
      ref="detailEdit"
    ></detailEdit>

    <detailView
      v-if="routeQuery.action === 'view'"
      :options="options"
      :dataForm="dataForm"
      ref="detailView"
    ></detailView>

    <ab-upload
      v-if="uploadParams.items && uploadParams.items.length > 0"
      :params="uploadParams"
      @update-billsId="updateBillsId" 
      ref="fileUpload"
    ></ab-upload>

    <ab-footer>
      <el-button @click="back">返回</el-button>

      <el-button
        v-if="this.dataForm.status === 1 || this.dataForm.status === 4"
        :loading="btnLoading"
        :disabled="!dataForm.canContinueSend"
        @click="continueDelivery"
      >继续发货</el-button>

      <el-button
        v-if="!this.dataForm.status || this.dataForm.status === 1 || this.dataForm.status === 4"
        :loading="btnLoading"
        @click="beforeSend('save')"
      >保存</el-button>

      <el-button
        v-if="!this.dataForm.status || this.dataForm.status === 1 || this.dataForm.status === 4"
        type="primary"
        :loading="btnLoading"
        @click="beforeSend('confirm')"
      >确认</el-button>

      <el-button
        type="primary"
        v-if="this.dataForm.status === 2"
        :loading="btnLoading"
        @click="revokeFun"
      >修改</el-button>

      <ab-revoke-sign
        :billId="dataForm.id"
        :show="['1', '4'].includes(dataForm.signStatus) && dataForm.status === 1"
        @callback="revokeSignFun"
      >撤回签章</ab-revoke-sign>
    </ab-footer>
  </div>
</template>

<script>
import detailEdit from './logistics-detail-edit.vue'
import detailView from './logistics-detail-view.vue'

export default {
  name: 'logistics-detail',
  components: {
    detailEdit,
    detailView,
  },

  data() {
    return {
      routeQuery: {},
      options: {},
      dataForm: {
        entry: []
      },
      deleteEntry: [],
      tempBillId: null,
      uploadParams: {
        coreBillIds: '',
        coreBillNumbers: '',
        sourceBillId: '',
        sourceBillNumber: '',
        sourceBillType: 'SendNotice',
        billType: '',
        items: []
      },
      btnLoading: false
    }
  },

  computed: {
    mainTabs: {
      get() {
        return this.$store.state.mainTabs
      },
      set(val) {
        this.$store.commit('updateMainTabs', val)
      }
    },

    mainTabsActiveName: {
      get() {
        return this.$store.state.mainTabsActiveName
      },
      set(val) {
        this.$store.commit('updateMainTabsActiveName', val)
      }
    }
  },

  mounted() {
    this.getSelectList()
  },
    watch: {
        'dataForm.sendType'(val){
            this.initUpload()
        }
    },

  activated () {
    let query = this.$route.query || {}
    this.routeQuery = Object.keys(query).length ? query : this.routeQuery
    if (
      typeof this.routeQuery.cache === "string"
        ? JSON.parse(this.routeQuery.cache)
        : this.routeQuery.cache
    ) {
      return false
    } else {
      this.routeQuery.cache = true
    }
    // if (this.routeQuery.cache && this.routeQuery.cache !== 'false') {
    //   return false
    // } else {
    //   this.routeQuery.cache = true
    // }
    // if (
    //   typeof this.routeQuery.cache === "string"
    //     ? JSON.parse(this.routeQuery.cache)
    //     : this.routeQuery.cache
    // ) {
    //   return false
    // } else {
    //   this.routeQuery.cache = true
    // }
    this.init()
  },

  methods: {
    removeTabHandle(tabName) {
      this.mainTabs = this.mainTabs.filter(item => item.index !== tabName)
      if (tabName) {
        this.$router.push({ path: '/delivery-history' })
      }
    },

    getSelectList() {
      this.$post('/tms/client/sendNotice/typeList').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.options = data.result
        } else {
          this.options = {}
        }
      })
    },

    init(type) {
      this.deleteEntry = []
      if (this.routeQuery.id) { // 编辑/详情
        this.$get('/tms/client/sendNotice/get', { id: this.routeQuery.id }).then(({ data }) => {
          if (data.code === 'C0000') {
            data.result.entry.forEach(row => {
              row.grossWeightOld = row.grossWeight
              row.pieceOld = row.piece
            })
            this.dataForm = data.result
            this.initUpload()
            if (type === 'confirm') {
              this.confirmFn()
            }
          }
        })
      } else { // 新增
        let list = JSON.parse(this.routeQuery.list)
        this.$post('/tms/client/sendNotice/getInitNew', { baseEntrustDtoList: list }).then(({ data }) => {
          if (data.code === 'C0000') {
            data.result.entry.forEach(row => {
              row.grossWeightOld = row.grossWeight
              row.pieceOld = row.piece
            })
            if (this.routeQuery.source) { // 订单创建发货通知
              data.result.sourceType = '02'
            }
            this.dataForm = data.result
            this.getDefaultAddress()
            this.initUpload()
            if (type === 'confirm') {
              this.confirmFn()
            }
          }
        })
      }
    },

    // 获取默认地址
    getDefaultAddress() {
      if (this.dataForm.bizBigType === '01') { // 进口-我的地址
        this.$post('/bas/client/basAddress/list', {
          data: { addressType: '01', isEnabled: 1, isDefault: 1 }
        }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            if (data.result.list.length) {
              this.dataForm.addressId = data.result.list[0].id
              this.dataForm.receiveAreaId = data.result.list[0].addressIds
              this.dataForm.addressIdsName = data.result.list[0].addressIdsName
              this.dataForm.receiveAddress = data.result.list[0].addressContent
              this.dataForm.receiveCompanyName = data.result.list[0].companyName
              this.dataForm.receiveLink = data.result.list[0].linkMan
              this.dataForm.receivePhone = data.result.list[0].linkPhone
            }
          }
        })
      } else { // 出口-客户下地址
        this.$post('/bas/client/basCustomer/checkAddress', { isEnabled: 1, isDefault: 1 }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            if (data.result && data.result.list && data.result.list.length) {
              this.dataForm.addressId = data.result.list[0].id
              this.dataForm.receiveAreaId = data.result.list[0].areaId
              this.dataForm.addressIdsName = data.result.list[0].addressIdsName
              this.dataForm.receiveAddress = data.result.list[0].takeAddress
              this.dataForm.receiveCompanyName = data.result.list[0].company
              this.dataForm.receiveLink = data.result.list[0].linkman
              this.dataForm.receivePhone = data.result.list[0].mobile
            }
          }
        })
      }
    },

    initUpload() {
      // 初始化上传组件
      this.uploadParams.sourceBillId = this.dataForm.id
      this.uploadParams.sourceBillNumber = this.dataForm.number

      setTimeout(() => {
        let items = [
          {
            title: '发货单',
            attachType: '020'
          },
          {
            title: '其它资料',
            attachType: '090'
          }
        ];
        if(this.dataForm.sendType == '01') {
          items.unshift(
            {
              title: '自提委托书',
              attachType: '010',
              required: this.dataForm.sendType === '01'
            }
          )
        }
        this.uploadParams.items = items
      }, 500)
    },

    // 附件临时id
    updateBillsId(tempBillId) {
      this.tempBillId = tempBillId
    },

    // 返回
    back() {
      this.removeTabHandle(this.mainTabsActiveName)
    },

    // 继续发货
    continueDelivery() {
      this.mainTabs = this.mainTabs.filter(item => item.name !== this.mainTabsActiveName)
      this.$router.push({
        path: '/delivery-notice',
        query: {
          custOrderNo: this.dataForm.custOrderNo
        }
      })
    },

    // 保存/确认前校验
    beforeSend(type) {
      if (!this.dataForm.status) {
        this.saveFn(type)
      } else if ([1, 4].includes(this.dataForm.status)) {
        this.btnLoading = true
        this.$get('/oms/client/entrustImport/checkIsLockedOrAudited', { id: this.dataForm.entry[0].entrustId }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            if (data.result) {
              if(type == 'save') {
                this.saveFn('save')
              }else {
                this.confirmFn()
              }
            }else{
              this.$message({
                type: 'error',
                message: '订单未锁定或审核，请先审核或处理订单!',
                offset: 380,
                grouping: true
              })
            }
          }
        }).finally(() => {
          setTimeout(() => {
            this.btnLoading = false
          }, 200)
        })
      }
    },

    // 保存
    saveFn(type) {
      this.$refs.detailEdit.$refs.dataForm.validate(valid => {
        if (valid) {
          let url = this.dataForm.id ? '/tms/client/sendNotice/mod' : '/tms/client/sendNotice/add'
          this.dataForm.tempBillId = this.tempBillId
          this.dataForm.addressIdDesc = this.dataForm.receiveAddress
          this.dataForm.count = this.sendQtySum
          this.dataForm.piece = this.pieceSum
          this.dataForm.grossWeight = this.grossWeightSum
          this.dataForm.cardBoard = this.cardBoardSum
          let params = Object.assign({}, this.dataForm)
          params.entry = this.dataForm.entry.concat(this.deleteEntry)
          if (this.$refs.detailEdit.$refs.abHistory) {
            this.$refs.detailEdit.$refs.abHistory.setHistory(this.dataForm.princiPalIdDesc, this.dataForm.idCard)
          }
          this.$post(url, params, this, 'btnLoading').then(({ data }) => {
            if (data && data.code === 'C0000') {
              this.$message({
                message: data.message,
                type: 'success',
                offset: 380,
                grouping: true
              })
              this.routeQuery.id = this.dataForm.id || data.result
              this.init(type)
            }
          })
        }
      })
    },

    // 确认
    confirmFn() {
      if (!this.dataForm.id) {
        this.saveFn('confirm')
        return
      }
      this.$refs.detailEdit.$refs.dataForm.validate(valid => {
        if (valid) {
          this.$refs.fileUpload.validate().then(fileValid => {
            if (fileValid) {
              this.dataForm.addressIdDesc = this.dataForm.receiveAddress
              this.dataForm.count = this.sendQtySum
              this.dataForm.piece = this.pieceSum
              this.dataForm.grossWeight = this.grossWeightSum
              this.dataForm.cardBoard = this.cardBoardSum
              let params = Object.assign({}, this.dataForm)
              params.entry = this.dataForm.entry.concat(this.deleteEntry)
              this.$post('/tms/client/sendNotice/confirm', params, this, 'btnLoading').then(({ data }) => {
                if (data && data.code === 'C0000') {
                  this.$message({
                    message: data.message,
                    type: 'success',
                    offset: 380,
                    grouping: true
                  })
                  this.back()
                  if (data.result) {
                    this.$router.push({
                      path: '/my-signature'
                    })
                    window.open(data.result)
                  }
                }
              })
            }
          })
        }
      })
    },

    // 修改（撤回）
    revokeFun() {
      this.$post('/tms/client/sendNotice/revoke', { id: this.dataForm.id }, this, 'btnLoading').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.$message({
            message: data.message,
            type: 'success',
            offset: 380,
            grouping: true
          })
          this.back()
        }
      })
    },

    // 撤回签章
    revokeSignFun(data) {
      if (data && data.code === 'C0000') {
        this.back()
      }
    }
  }
}
</script>

<style lang="scss">
.logistics-detail {
  position: relative;
  padding: 35px 0 0 0;
  text-align: left;
  border-top: 1px solid #f0f2f5;
  font-size: 14px;
  color: #000000;
  .el-table th.must > .cell:after {
    content: ' *';
    color: #ff1818;
  }
  .el-form-item__label {
    color: #000000;
  }
  h3 {
    font-size: 18px;
    margin-bottom: 33px;
  }
  .dataForm {
    .logisticsInfo {
      .el-col.el-col-8 {
        margin-bottom: 2px;
      }
    }
  }
  .logisticsInfo {
    border-bottom: 1px solid #f0f2f5;
    margin-bottom: 35px;
    padding-bottom: 20px;
    .el-col.el-col-8 {
      margin-bottom: 20px;
    }
    .supplierName {
      width: 100%;
      display: flex;
      padding: 20px 0;
      border-bottom: 1px solid #f0f2f5;
      line-height: 24px;
      .supplier {
        padding: 5px 12px;
        height: 24px;
        margin-right: 20px;
        line-height: 14px;
        border-radius: 4px;
        background-color: #f0f2f5;
        span {
          color: #fe2424;
        }
      }
      .icon-svg {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        margin: 0 10px;
        cursor: pointer;
      }
      p {
        font-size: 22px;
        font-weight: bold;
      }
    }
    .receivingAddress {
      font-size: 14px;
      font-weight: 400;
      margin: 18px 0 17px 0;
      .icon-svg {
        width: 11px;
        height: 16px;
        vertical-align: bottom;
      }
    }
    .el-alert {
      margin: 32px 0 20px;
    }
    .remark {
      margin-top: 32px;
      .el-textarea {
        .el-textarea__inner {
          min-height: 45px !important;
          padding-top: 11px;
          box-shadow: 0 0 0 1px transparent;
          &:focus {
            box-shadow: 0 0 0 1px var(--el-input-focus-border-color) inset;
          }
        }
      }
    }
  }
  .goodsInfo {
    margin-bottom: 30px;
    > h3 {
      margin-bottom: 37px;
    }
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      justify-content: space-between;
      h3 {
        margin: 0;
      }
    }
    .materialTable {
      margin-bottom: 36px;
      .vxe-table--header-wrapper {
        position: static !important;
      }
    }
    .el-row {
      .el-col.el-col-6 {
        span {
          font-size: 14px;
          color: #636871;
        }
        div {
          font-size: 30px;
          font-weight: 500;
          margin-top: 20px;
        }
      }
    }
  }

  .footer {
    margin-top: 20px;
    padding: 20px 0;
    text-align: center;
  }
  // 标签
  .logistics-number {
    position: absolute;
    width: 200px;
    top: 0px;
    right: 0px;
    border-radius: 0 0 8px 8px;
    background-color: #f2f7ff;
    font-size: 14px;
    text-align: center;
    .text {
      padding: 10px 0;
      border-bottom: 1px solid #f0f2f5;
    }
    .time {
      padding: 10px 0;
    }
  }
}
</style>
